import * as angular from 'angular';
import * as _ from 'lodash';
import AuthService from '../../common/services/auth.service';
import ComponentController from '../../common/components/component-controller';

const templateUrl = require('./logout.html');

class LogoutController extends ComponentController {
  constructor(private $window: any, private auth: AuthService, private classicUrl: string) {
    super();

    auth.logout();
    $window.location.href = `${classicUrl}user/sign_out`;
  }
}

angular.module('ciApp').component('logout', {
  controller: ['$window', 'AuthService', 'classicUrl', LogoutController],
  templateUrl
});



// WEBPACK FOOTER //
// ./app/logout/logout.component.ts